import { render } from "./CopyRightLabel.vue?vue&type=template&id=c545f374"
import script from "./CopyRightLabel.vue?vue&type=script&lang=js"
export * from "./CopyRightLabel.vue?vue&type=script&lang=js"

import "./CopyRightLabel.vue?vue&type=style&index=0&id=c545f374&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__